export default __webpack_public_path__ + "static/media/349588.01d41232.jpg";